import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

/**
 * A date-fns pattern rendered in the venue's zone (browser zone when none is
 * known): a 5pm game in New York stays 5pm for a viewer abroad.
 */
export const formatInVenueZone = (
  date: Date | string,
  pattern: string,
  timezone?: string | null,
): string => {
  const value = typeof date === 'string' ? new Date(date) : date;
  return timezone ? formatInTimeZone(value, timezone, pattern) : format(value, pattern);
};
